import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const borderColor = "#ccc";
const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    borderBottomColor: borderColor,
    borderBottomWidth: 1,
    alignItems: "center",
    fontStyle: "bold",
  },
  description: {
    width: "28%",
    height: 20,
    paddingTop: 5,
    fontSize: 9,
    paddingLeft: 5,
    borderColor: borderColor,
    borderWidth: 1,
  },
  rowWidth: {
    width: "18%",
    height: 20,
    paddingTop: 5,
    fontSize: 9,
    textAlign: "center",
    borderColor: borderColor,
    borderWidth: 1,
  },
});

const SpecieYOYRow = ({ items }) => {
  const rows = items.map((item, i) => {
    return (
      <View style={styles.row}>
        <Text style={styles.description}>{item.name}</Text>
        <Text style={styles.rowWidth}>{item.live_intake}</Text>
        <Text style={styles.rowWidth}>{item.live_outcome}</Text>
        <Text style={styles.rowWidth}>{item.other_outcome}</Text>
        <Text style={styles.rowWidth}>
          {item.live_outcome + item.other_outcome}
        </Text>
      </View>
    );
  });
  return <Fragment>{rows}</Fragment>;
};

export default SpecieYOYRow;
